import { render, staticRenderFns } from "./TableHostingInstitutions.vue?vue&type=template&id=435cb362"
import script from "./TableHostingInstitutions.vue?vue&type=script&lang=js"
export * from "./TableHostingInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports